import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';
import DIMENSIONS from '../../library/dimensions';

const errorHeight = 72;
const Color = require('color');

const styles = StyleSheet.create({
  root: {
    position: 'fixed',
    bottom: 50 - 240,
    left: DIMENSIONS.sidebarWidth/2,
    width: '100%',
    zIndex: 999,
    transition: '300ms ease-in',
    display: 'flex',
    alignItems: 'center'
  },
  visibleRoot: {
    transform: `translateY(-240px)`,
    transition: '300ms ease-out'
  },
  content: {
    //width: '100%',
    // maxWidth: 600,
    margin: '0 auto',
    paddingLeft: 32,
    paddingRight: 36,
    height: errorHeight,
    background: COLORS.allureGreen,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 4,
    boxShadow: '1px 1px 8px rgba(0,0,0,0.32)'
  },
  check: {
    color: 'white',
    fontSize: 16,
    marginRight: 24,
    fontWeight: 'bold',
    opacity: 0.65
  },
  successMessageText: {
    color: 'white',
    flex: 1,
    fontSize: 14,
    textShadow: `1px 1px 1px ${Color(COLORS.allureGreen).darken(0.48)}`,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/snackbars/success-message-styles.js